import { useDisclosure, useToast } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import useModelButtonTelemedicina from 'components/Dashboard/ButtonTelemedicina/useModelButtonTelemedicina';
import { useContext, useEffect, useState } from 'react';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useViewModelTelemed = (props) => {
  const [motivos, setOpcoesMotivos] = useState([]);
  const [motivo_escolhido, setMotivoEscolhido] = useState(0);
  const [modalDesistir, setModalDesistir] = useState(false);
  const [loading, setLoading] = useState(false);
  const [atendimentoEscolhido, setAtendimentoEscolhido] = useState(null);

  const { user } = useContext(AccountContext);
  const [error, setError] = useState(false);
  const modalSuporte = useDisclosure();
  const modalCancelamento = props.modalCancelamento;
  const refetchFila = props.refetchAtendimento
  const toast = useToast();

  function callToast(title, descricao, status, color) {
    console.log('chamando toast ', title, descricao, status, color);
    toast({
      title: title,
      description: descricao,
      status: status,
      duration: 4000,
      isClosable: true,
      position: 'bottom',
      colorScheme: color,
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }

  async function searchCancel() {
    try {
      let url = ENDPOINT + '/schedule/get_motivos_cancelamento';
      const resposta = await api(url, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });
      const postsDados = await resposta.json();
      setOpcoesMotivos(postsDados);
    } catch (error) {
      setOpcoesMotivos([]);
    }
  }
  //removendo do cache do cliente
  async function deleteFromCache() {
    setLoading(true);
    try {
      await api(`${ENDPOINT}/cache/telemedicine/${atendimentoEscolhido.agenda_exames_id}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(async (res) => {
        if (res.status === 400) {
          callToast(
            'Falha ao tentar cancelar o atendimento',
            'Houve uma falha ao tentar cancelar seu atendimento. Entre em contato com nosso suporte',
            'error',
            'red'
          );
          setError(true);
          return;
        }
        refetchFila()
        callToast(
          'Atendimento cancelado com sucesso',
          'Seu agendamento foi cancelado com sucesso. Em caso de dúvidas, entre em contato com nosso suporte',
          'success',
          'green'
        );
        modalCancelamento.onClose();
        return;
      });
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  }

  //atualizando motivo de cancelamento no banco
  async function cancelarAtendimento() {
    try {
      await api(`${ENDPOINT}/clients/cancelarAtendimento`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          paciente_id: user.id_cliente_deovita,
          cpf: user.username,
          agendamentoId: atendimentoEscolhido.agenda_exames_id,
          motivo_escolhido,
        }),
      })
        .then(async (res) => {
          if (!res || !res.ok || res.status >= 400) {
            console.log(res);
            return;
          }
          return await res.json();
        })
        .then(async (resposta) => {
          setLoading(false);
          if (!resposta.success) {
            callToast(
              'Falha ao tentar cancelar o atendimento',
              'Houve uma falha ao tentar cancelar seu atendimento. Entre em contato com nosso suporte',
              'error',
              'red'
            );
            setError(true);
            return;
          }
          await deleteFromCache();
        });
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  }

  const modalfuncDesistir = () => {
    setModalDesistir((prev) => !prev);
  };

  useEffect(() => {
    searchCancel();
  }, []);

  /*
    useEffect(() => {
      setMotivoEscolhido(motivo_escolhido);
    }, [motivo_escolhido]);
  */

  return {
    motivos,
    setMotivoEscolhido,
    modalDesistir,
    modalfuncDesistir,
    modalSuporte,
    motivo_escolhido,
    loading,
    cancelarAtendimento,
    error,
    atendimentoEscolhido,
    setAtendimentoEscolhido,
  };
};

export default useViewModelTelemed;
